/** @jsxImportSource @emotion/react */
import { useContext } from 'react';

import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import { Text } from 'components/Text';
import { StylingContext } from 'context/Styling';
import { PUBLIC_URL } from 'utils/consts';
import { useStyles } from 'utils/useStyles';

import { mfaPromptModalStyles } from './MfaPromptModal.styles';

export interface MfaPromptModalProps {
  isOpen: boolean;
  onSetupMfa: () => void;
  onSkip: () => void;
}

export const MfaPromptModal = ({ isOpen, onSetupMfa, onSkip }: MfaPromptModalProps) => {
  const {
    viewport: { md },
  } = useContext(StylingContext);
  const styles = useStyles(mfaPromptModalStyles);

  return (
    <Modal isOpen={isOpen} ariaLabel="Set up two-factor authentication">
      <div css={styles.content}>
        <div css={styles.header}>
          <img src={`${PUBLIC_URL}/img/grafana-cloud-logo-for-light-theme.svg`} alt="Grafana Cloud" css={styles.logo} />
          <Text component="h2" css={styles.heading} type="large">
            Secure Your Account with Two-Factor Authentication
          </Text>
        </div>

        <Text css={styles.description} type="normal">
          Two-factor authentication adds an extra layer of security to your account. Even if someone knows your
          password, they won&apos;t be able to access your account without the second factor from your authenticator
          app.
        </Text>

        <div css={styles.actions}>
          <Button
            id="mfa-prompt-skip"
            label="Maybe Later"
            onClick={onSkip}
            variant="white"
            width={md ? 'auto' : 'full'}
            css={styles.secondaryButton}
            trackingLabel="mfa-prompt-skip"
          />
          <Button
            id="mfa-prompt-setup"
            label="Set Up Now"
            onClick={onSetupMfa}
            variant="primary"
            width={md ? 'auto' : 'full'}
            css={styles.primaryButton}
            trackingLabel="mfa-prompt-setup"
          />
        </div>
      </div>
    </Modal>
  );
};
